const SignUpService = (() => {
    /**
     * @param {string} country 
     * @param {string} lang 
     * @param {object} userData 
     * 
     * @return {object} - { success, show_otp, data, message, error, urlType }
     */
    const r4SignUp = (country, lang, userData) => {
        return new Promise((resolve, reject) => {
            try {
                triggerRouterCreateSession(country, lang)
                    .then(({ sessionId, encryptedSessionId, clientIp, dataCenter }) => {
                        if (sessionId) {
                            triggerRouterAddCustomer(sessionId, country, lang, userData) // add customer api
                                .then((registerResp) => {
                                    if (registerResp?.data?.addCustomer?.status === 'CREATED' &&
                                        registerResp?.data?.addCustomer?.["__typename"] === 'SuccessResponse') {
                                        resolve({
                                            success: true,
                                            data: null,
                                            message: null,
                                            error: null,
                                            urlType: 'start',
                                        });
                                    }
                                    if (registerResp?.data?.addCustomer?.error?.err === "EA1035") {
                                        sessionStorage.setItem('sc_register_success', 'true');

                                        resolve({
                                            success: false,
                                            show_otp: true,
                                            data: {
                                                sessionData: {
                                                    sessionId,
                                                    encryptedSessionId,
                                                    clientIp,
                                                    dataCenter,
                                                },
                                            },
                                            message: null,
                                            error: null,
                                            urlType: null,
                                        });
                                    } else if (registerResp?.data?.addCustomer["__typename"] === 'ErrorResponse') {
                                        resolve({
                                            success: false,
                                            data: null,
                                            message: registerResp?.data?.addCustomer?.message,
                                            error: registerResp,
                                            urlType: null,
                                        });
                                    } else {
                                        resolve({
                                            success: false,
                                            data: null,
                                            message: null,
                                            error: registerResp,
                                            urlType: null,
                                        });
                                    }
                                }).catch(error => {
                                    console.error(error)
                                    resolve({
                                        success: false,
                                        data: null,
                                        message: null,
                                        error,
                                        urlType: null,
                                    });
                                })
                        } else {
                            resolve({
                                success: false,
                                data: null,
                                message: null,
                                error: null,
                                urlType: null,
                            });
                        }
                    }).catch(error => {
                        console.error(error)
                        resolve({
                            success: false,
                            data: null,
                            message: null,
                            error,
                            urlType: null,
                        });
                    })
            } catch (error) {
                console.error('error from trigger register : ', error)
                resolve({
                    success: false,
                    data: null,
                    message: null,
                    error,
                    urlType: null,
                });
            }
        });
    };

    /**
     * @param {string} country 
     * @param {string} countryText 
     * @param {string} lang 
     * @param {string} host 
     * @param {object} userData 
     * 
     * @return {object} - { success, data, message, error, urlType }
     */
    const r3SignUp = (country, countryText, lang, host, userData) => {
        return new Promise((resolve, reject) => {
            try {
                const createSessionCatalogConfig = triggerCreateSession(country, lang, host);

                httpRequest.post(createSessionCatalogConfig.createSessionurl, createSessionCatalogConfig.reqPayload, { "Content-type": "application/json" })
                    .then((response) => {
                        const clientIp = response?.security?.client_ip ? response.security.client_ip : '245024209201'
                        const sessionId = response?.security?.session.id
                        const encryptedSessionId = response?.security?.session.encrypted_session_id
                        setCookieOnCreateSessionResponse(response);
                        StorageService.setDataInStorage(
                            country,
                            lang,
                            sessionId,
                            encryptedSessionId,
                            userData,
                            countryText
                        );

                        if (clientIp && sessionId) {
                            triggerValidateEmail(userData.emailId, sessionId, clientIp)
                                .then((validateEmailResp) => {
                                    if (validateEmailResp?.error?.code === 'C6017') {
                                        triggerRegisterGWPApi(sessionId, userData.emailId, userData.password)
                                            .then((registerResp) => {
                                                if (registerResp?.error?.code === 'C6006') {
                                                    if (registerResp?.error?.reasons?.reason?.filter((reason) => reason.code === "11512")) {
                                                        resolve({
                                                            success: false,
                                                            data: null,
                                                            message: null,
                                                            error: null,
                                                            urlType: 'register-verify-email',
                                                        });
                                                    } else {
                                                        resolve({
                                                            success: false,
                                                            data: null,
                                                            message: null,
                                                            error: registerResp,
                                                            urlType: null,
                                                        });
                                                    }
                                                } else {
                                                    triggerCustomerSignOn(country, lang, sessionId, clientIp, userData, location.host)
                                                        .then((singOnResponse) => {
                                                            if (singOnResponse?.gatewayCustomer?.preferredCustomer?.accountNbr) {

                                                                const accNumber = singOnResponse?.gatewayCustomer?.preferredCustomer?.accountNbr;
                                                                setR3SendeGatewayrDetails(sessionId, encryptedSessionId, country, lang, userData, singOnResponse);
                                                                CookieService.setCookie('userIdentity', 'registeredCustomer', 365, location.pathname);

                                                                triggerGetLoyaltycards(sessionId, clientIp, accNumber, location.host)
                                                                    .then((loyalityResponse) => {
                                                                        setR3LoyalityCard(loyalityResponse);

                                                                        resolve({
                                                                            success: true,
                                                                            data: null,
                                                                            message: null,
                                                                            error: null,
                                                                            urlType: 'start',
                                                                        });
                                                                    }).catch(error => {
                                                                        console.error(error)
                                                                        resolve({
                                                                            success: false,
                                                                            data: null,
                                                                            message: null,
                                                                            error,
                                                                            urlType: null,
                                                                        });
                                                                    })
                                                            } else {
                                                                resolve({
                                                                    success: false,
                                                                    data: null,
                                                                    message: null,
                                                                    error: singOnResponse,
                                                                    urlType: null,
                                                                });
                                                            }
                                                        }).catch(error => {
                                                            console.error(error)
                                                            resolve({
                                                                success: false,
                                                                data: null,
                                                                message: null,
                                                                error,
                                                                urlType: null,
                                                            });
                                                        })
                                                }
                                            }).catch(error => {
                                                console.error(error)
                                                resolve({
                                                    success: false,
                                                    data: null,
                                                    message: null,
                                                    error,
                                                    urlType: null,
                                                });
                                            })
                                    } else {
                                        resolve({
                                            success: false,
                                            data: null,
                                            message: null,
                                            error: validateEmailResp,
                                            urlType: null,
                                        });
                                    }
                                }).catch(error => {
                                    console.error(error)
                                    resolve({
                                        success: false,
                                        data: null,
                                        message: null,
                                        error,
                                        urlType: null,
                                    });
                                })
                        } else {
                            resolve({
                                success: false,
                                data: null,
                                message: null,
                                error: null,
                                urlType: null,
                            });
                        }
                    }).catch(error => {
                        console.error(error)
                        resolve({
                            success: false,
                            data: null,
                            message: null,
                            error,
                            urlType: null,
                        });
                    })
            } catch (error) {
                console.error('error from trigger register : ', error)
                resolve({
                    success: false,
                    data: null,
                    message: null,
                    error,
                    urlType: null,
                });
            }
        });
    };

    /**
     * @param {string} country 
     * @param {string} countryText 
     * @param {string} lang 
     * @param {string} host 
     * @param {object} userData 
     * @param {boolean} isR4 
     * 
     * @return {object} - { success, data, message, error, urlType }
     */
    const signUp = (country, countryText, lang, host, userData, isR4 = false) => {
        if (isR4) {
            return r4SignUp(country, lang, userData);
        }

        return r3SignUp(country, countryText, lang, host, userData);
    };

    return {
        signUp,
        r4SignUp,
        r3SignUp,
    };
})();